import { useMemo } from 'react';

import { createQuery } from '@luna/api';

import { fetchAccountServiceOperations } from '../services/accountServiceOperationsService';
import { findActionGroups } from '../services/findAccountServiceOperationsService';
import type {
    AccountServiceOperationsFilterCriteria,
    ServiceActionGroup,
} from '../types/accountServiceOperations';

interface HookResult {
    data: ServiceActionGroup[];
    isPending: boolean;
    isError: boolean;
}

const DEFAULT_ACTION_GROUPS_FILTER_CRITERIA = {
    categories: [],
    subcategories: [],
    actionGroups: [],
    actions: [],
};

const [useAccountServiceOperationsQuery] = createQuery({
    name: 'products/account-service-operations',
    cacheKey: (productId) => productId,
    payloadCreator: fetchAccountServiceOperations,
});

export const useAccountServiceOperations = (
    productId: string,
    filterCriteria: AccountServiceOperationsFilterCriteria,
): HookResult => {
    const { data, isPending, error } = useAccountServiceOperationsQuery(productId);

    const actionGroupsFilterCriteria = {
        ...DEFAULT_ACTION_GROUPS_FILTER_CRITERIA,
        ...filterCriteria,
    } satisfies AccountServiceOperationsFilterCriteria;

    const result = useMemo(
        () => findActionGroups(data, actionGroupsFilterCriteria),
        [data, actionGroupsFilterCriteria],
    );

    return { data: result, isPending, isError: !!error };
};
